import React, { FC } from "react";

import { DottedJoin } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import { IgColorPicker } from "./IgColorPicker";

interface IgColorPickerGroupItem {
  path: DottedJoin<any>;
  key: string;
  label: string;
  value: string;
}
export type IgColorPickerGroupItems = IgColorPickerGroupItem[][];

interface IgColorPickerGroupProps {
  // Group if items, items per row
  id: string;
  items: IgColorPickerGroupItems;
  onChange: (key: DottedJoin<any>, value: string) => void;
  disabled: boolean;
}

/**
 * @see Grid
 * @see IgColorPicker
 */
export const IgColorPickerGroup: FC<IgColorPickerGroupProps> = ({
  id,
  items,
  onChange,
  disabled,
}) => {
  return (
    <Grid container item alignContent={"start"} spacing={2}>
      {items.map((row, rowIndex) => {
        return (
          <Grid
            container
            item
            // sx={{ height: "69px" }}
            key={`color-picker-group-${id}row-${rowIndex}`}
            columnSpacing={5}
            rowSpacing={2}
          >
            {row.map((item, itemIndex) => {
              return (
                <Grid
                  item
                  key={`color-picker-group-row-${rowIndex}-item-${itemIndex}`}
                >
                  <IgColorPicker
                    shouldAlignLeft={itemIndex % 2 === 0}
                    disabled={disabled}
                    label={item.label}
                    value={item.value || ""}
                    onChange={(e) => onChange(item.path, e)}
                  />
                </Grid>
              );
            })}
          </Grid>
        );
      })}
    </Grid>
  );
};
